import styled from "styled-components";

export const FormWrapper = styled.div`
    padding: 25px;
    background: #FFFFFF;
    border: 1.5px solid rgba(211, 211, 211, 0.5);
    border-radius: 15px;
    max-height: calc(100vh - clamp(187px,10.417vw,200px));
    /* overflow: auto; */
    display: flex;
    flex-direction: column;
    /* border: 1.5px solid #00558680; */
    box-shadow: 0px 7px 4.5px 0px #0000000D;
    /* background: linear-gradient(176.81deg, #FFFFFF 4.22%, #E9F8FF 97.36%); */
   .loan-detail-wrapper {
    display: grid;
    align-items: flex-end;
    grid-template-columns: 1fr 1fr 2fr 1fr;
    gap: 20px;
    .other-label{
        position: absolute;
        bottom: 35px;
    }
    > button {
        height: clamp(27px,1.875vw,36px);
        width: clamp(80px,5.417vw,104px);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: clamp(10px,0.729vw,14px);
        background: #FFFFFF;
        border: 1px solid #303030;
        border-radius: clamp(27px,1.875vw,36px);
        gap: 5px;
        > svg {
            width: clamp(11px,0.781vw,15px);
            height: clamp(11px,0.781vw,15px);
        }
        &.add-more {
            background: linear-gradient(90deg, #55C416 0%, #367910 100%);
            border-color: transparent;
            color: #fff;
        }
    }
   }
   .comment-section{
        grid-template-columns: 5fr;
        gap: clamp(15px,2.083vw,40px);
        textarea{
            outline: none;
        }
    }
   .business-name-wrapper {
    display: flex;
    gap: min(5.313vw, 102px);
    align-items: flex-end;
    margin-bottom: 15px;
    > .app-input-text {
        width: 100%;
        max-width: 896px;
    }
    .equipment-requirements-wrapper {
        max-width: 630px;
        width: 100%;
        margin-right: 50px;
        margin-bottom: 10px;
        .requirements-checkbox {
            display: flex;
            justify-content: space-between;
            margin-right: 75px;
            .radio-checkmark{
                width: 17px;
                height: 17px;
                border-radius: 0px;
                }
            .radio-checkmark:after {
                top: 3px !important;
                left: 3px !important;
                width: 10px !important;
                height: 10px !important;
                border-radius: 0px !important;
            }
        }
    }
    }
    > div {
        display: flex;
        gap: clamp(20px, 6.25vw, 120px);
        > div {
            flex: 1;
            min-width: 860px;
            :nth-child(2) {
                max-width: 655px;
                min-width: auto;
            }
    }
    }
    .sec-label {
        font-size: clamp(12px,0.833vw,16px);
        /* line-height: 19px; */
        letter-spacing: 0.005em;
        color: #000;
        font-family: "latobold";
        margin-bottom: 15px;
    }
    .label-heading {
        font-weight: 700;
        font-size: clamp(14px,0.833vw,16px);
        line-height: normal;
        letter-spacing: 0.005em;
        color: #005586;
        margin-bottom: clamp(16px,1.146vw,22px);
    }
    .label-heading-lots1{
        margin-bottom: 20px;
    }    
    .label-heading-lots2{
        margin-bottom: 18px;
        text-align: center;
    }
    .label-heading-lots3{
        margin-bottom: 22px;
        text-align: center;
    }
    .button-wrapper{
        display: flex;
        gap: 10px;
        justify-content: center;
        button{
            margin: 0px;
            width: 160px;
            padding: 0 15px;
        }
        .disabled-button{
            opacity: 0.5;
        }
    }
    .reset-button{
        background: #E4E3E3 !important;
        border: none !important;
    }
    .submit-button{
        background: linear-gradient(90deg, #55C416 0%, #367910 100%) !important;
        border: none !important;
        color: #fff;
        white-space: nowrap;
    }
    .update-button{
        background: linear-gradient(90deg, #55C416 0%, #367910 100%) !important;
        border: none !important;
        color: #fff;
        width: fit-content !important;
    }
    .react-select__single-value{
        font-size: 13px;
    }
    @media (max-width: 1626px) {
        > div {
            > div {
                min-width: 730px;
            }
        }
    }
    @media (max-width: 1478px) {
        > div {
            gap: 40px;
            > div {
                min-width: auto;
            }
        }
    }
    @media (max-width: 1277px) {
        > div {
            > div {
                min-width: 565px;
            }
        }
    }

    .star {
    color: red;
    }
`

export const NoVenderAvailableBannerWrapper = styled.div`
    position: absolute;
    top: 65px;
    bottom: 0;
    right: 0;
    left: 0;
    background: #00000070;
    z-index: 2;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    p {
      border-radius: 7px;
      height: 200px;
      border: 1px solid #cfcfcf;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px;
      max-width: 650px;
      justify-content: center;
      background-color: #fff;
      font-size: 18px;
      button{
        background: linear-gradient(180deg, #61b01f 0, #27911b) !important;
        border-radius: 4px;
        width: 80px;
        height: 31px;
        font-size: 13px;
        line-height: 19px;
        color: #ffffff;
        margin-top: 20px;
        border: none;
      }
    }
`